(function() {
  if (window.LeonYoutubeGallery) return;

  // ---------- Consent-Check ----------
  // Shopify Customer Privacy API: window.Shopify.customerPrivacy
  // Consentmo registriert sich an dieser API → wir nutzen den offiziellen Layer

  function hasMarketingConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return false;
      return cp.marketingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  function requestMarketingConsent(onAccepted) {
    // Bewusste Design-Entscheidung: KEIN globaler Consent-Set hier.
    //
    // Stattdessen klassische 2-Klick-Lösung (LG München 2022):
    // Der User akzeptiert das EINE Video, das er gerade ansehen möchte.
    // Persistenter Marketing-Consent bleibt eine bewusste Entscheidung,
    // die nur über die globale Consentmo-Wall gesetzt werden kann.
    //
    // Damit ist sichergestellt, dass der YouTube-Klick nicht versehentlich
    // Analytics/Marketing für die gesamte Seite aktiviert.
    if (typeof onAccepted === 'function') onAccepted();
  }

  // ---------- Thumbnail-Upgrade ----------
  // Bei Consent: ersetzt SVG-Placeholder durch i.ytimg.com Thumbnail
  // Wenn nicht: belässt SVG-Placeholder (rechtssicher, kein Request an Google)
  //
  // Wir nutzen hqdefault (480x360) als primary: ist für ALLE Videos verfügbar
  // und auf 220x124 Thumbnail mehr als ausreichend scharf. maxresdefault wäre
  // schöner, ist aber nicht für alle (besonders ältere/kurze) Videos verfügbar
  // → würde 120px-Placeholder zeigen bis Fallback greift. Race vermeiden = hqdefault.

  function upgradeThumbnails(root) {
    if (!hasMarketingConsent()) return;

    var triggers = root.querySelectorAll('[data-lyg-trigger]');
    triggers.forEach(function(btn) {
      if (btn.dataset.lygThumbLoaded === '1') return;
      btn.dataset.lygThumbLoaded = '1';

      var vid = btn.getAttribute('data-lyg-vid');
      if (!vid) return;

      var thumbWrap = btn.querySelector('[data-lyg-thumb]');
      if (!thumbWrap) return;

      var img = document.createElement('img');
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = '';
      img.className = 'lyg__img';
      img.width = 320;
      img.height = 180;

      // WICHTIG: Image MUSS zuerst ins DOM, dann src setzen.
      // Sonst hängt loading="lazy" (Browser ignoriert nicht-eingehängte Images).
      thumbWrap.appendChild(img);

      img.onload = function() {
        var placeholder = thumbWrap.querySelector('.lyg__placeholder');
        if (placeholder) placeholder.style.display = 'none';
      };
      // onerror: SVG-Placeholder bleibt einfach sichtbar (Default)

      img.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(vid) + '/hqdefault.jpg';
    });
  }

  // ---------- Modal-Build & Lifecycle ----------

  var activeModal = null;
  var lastFocus = null;

  // iFrame-Builder: extrahiert weil 2× verwendet (Initial-Build + Consent-Accept)
  function buildIframe(vid) {
    var iframe = document.createElement('iframe');
    iframe.className = 'lyg-modal__iframe';
    iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(vid) + '?autoplay=1&rel=0&modestbranding=1');
    iframe.setAttribute('title', 'YouTube-Video Player');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    return iframe;
  }

  function buildModal(vid, hasConsent) {
    var overlay = document.createElement('div');
    overlay.className = 'lyg-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'YouTube-Video');

    var inner = document.createElement('div');
    inner.className = 'lyg-modal__inner';
    overlay.appendChild(inner);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'lyg-modal__close';
    closeBtn.setAttribute('aria-label', (window.TBT && window.TBT['tb.general.close']) || 'Schließen'); /* TB V9.94 */
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    inner.appendChild(closeBtn);

    var stage = document.createElement('div');
    stage.className = 'lyg-modal__stage';
    inner.appendChild(stage);

    if (hasConsent) {
      stage.appendChild(buildIframe(vid));
    } else {
      // Consent-Wall
      stage.innerHTML = ''
        + '<div class="lyg-consent">'
        +   '<svg class="lyg-consent__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2 L3 7 v6 c0 5 4 8 9 9 c5-1 9-4 9-9 V7 z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M9 12 l2 2 l4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        +   '<h3 class="lyg-consent__title">YouTube-Video laden?</h3>'
        +   '<p class="lyg-consent__text">Beim Abspielen werden Daten an <b>YouTube (Google)</b> übertragen und Cookies gesetzt. Mehr dazu in unserer <a href="/policies/privacy-policy" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>'
        +   '<div class="lyg-consent__actions">'
        +     '<button type="button" class="lyg-consent__btn lyg-consent__btn--primary" data-lyg-accept>Akzeptieren &amp; abspielen</button>'
        +     '<button type="button" class="lyg-consent__btn lyg-consent__btn--secondary" data-lyg-decline>Abbrechen</button>'
        +   '</div>'
        + '</div>';

      var acceptBtn = stage.querySelector('[data-lyg-accept]');
      var declineBtn = stage.querySelector('[data-lyg-decline]');

      acceptBtn.addEventListener('click', function() {
        requestMarketingConsent(function() {
          // iFrame in-place austauschen
          stage.innerHTML = '';
          stage.appendChild(buildIframe(vid));

          // Thumbnails der Gallery upgrade (für den User der jetzt akzeptiert hat)
          document.querySelectorAll('[data-lyg-root]').forEach(upgradeThumbnails);
        });
      });

      declineBtn.addEventListener('click', closeModal);
    }

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    // Focus-Trap
    overlay.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusable = overlay.querySelectorAll('button, [href], iframe, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    });

    return overlay;
  }

  function onEscape(e) {
    if (e.key === 'Escape') closeModal();
  }

  function openModal(vid, triggerEl) {
    if (activeModal) closeModal();
    lastFocus = triggerEl;

    var consent = hasMarketingConsent();
    activeModal = buildModal(vid, consent);
    document.body.appendChild(activeModal);
    document.body.style.overflow = 'hidden';

    // Escape-Listener nur attachen wenn Modal offen ist
    document.addEventListener('keydown', onEscape);

    // Trigger reflow then add opening-class for transition
    activeModal.offsetHeight; // eslint-disable-line no-unused-expressions
    activeModal.classList.add('is-open');

    setTimeout(function() {
      var firstFocusable = activeModal.querySelector('button, iframe');
      if (firstFocusable) firstFocusable.focus();
    }, 60);
  }

  function closeModal() {
    if (!activeModal) return;
    var modal = activeModal;
    activeModal = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onEscape);
    modal.classList.remove('is-open');
    setTimeout(function() {
      if (modal.parentNode) modal.parentNode.removeChild(modal);
    }, 240);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  // ---------- Progress-Indikator + Nav-Buttons (updateUi) ----------
  // Synchronisiert die blaue Progress-Bar UND den Nav-Button-State mit
  // der Scroll-Position des Viewports.
  //
  // Formel (analog zu lgv):
  //   bar.width        = (clientWidth / scrollWidth) * trackWidth
  //   bar.translateX   = (scrollLeft / scrollWidth) * trackWidth
  //
  // Nav-State:
  //   prev.aria-disabled = scrollLeft <= 0
  //   next.aria-disabled = scrollLeft >= scrollWidth - clientWidth - 1
  //   progress.hidden    = scrollWidth <= clientWidth + 1 (kein Scroll nötig)
  //   nav-buttons.hidden = scrollWidth <= clientWidth + 1
  //
  // Mobile-Optimierung: Bar hat per CSS `transition: none` auf Mobile →
  // springt 1:1 mit Touch-Scroll ohne Lag.

  function initSlider(root) {
    var viewport = root.querySelector('[data-lyg-viewport]');
    var track = root.querySelector('[data-lyg-track]');
    var progress = root.querySelector('[data-lyg-progress]');
    var bar = root.querySelector('[data-lyg-progress-bar]');
    var prevBtn = root.querySelector('[data-lyg-nav="prev"]');
    var nextBtn = root.querySelector('[data-lyg-nav="next"]');
    if (!viewport || !track || !progress || !bar) return;

    var rafId = null;

    function updateUi() {
      rafId = null;
      var sw = viewport.scrollWidth;
      var cw = viewport.clientWidth;
      var sl = viewport.scrollLeft;
      var maxScroll = Math.max(0, sw - cw);
      var needsScroll = maxScroll > 1;

      // Progress-Bar
      if (!needsScroll) {
        progress.hidden = true;
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        return;
      }
      progress.hidden = false;
      var trackW = progress.clientWidth;
      var barWidth = (cw / sw) * trackW;
      var barOffset = (sl / sw) * trackW;
      bar.style.width = barWidth + 'px';
      bar.style.transform = 'translateX(' + barOffset + 'px)';

      // Nav-Buttons (nur Desktop sichtbar via CSS-Media-Query,
      // hidden-Attribute regelt zusätzlich Auto-Hide bei kein-Scroll)
      if (prevBtn) {
        prevBtn.hidden = false;
        prevBtn.setAttribute('aria-disabled', sl <= 0 ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.hidden = false;
        nextBtn.setAttribute('aria-disabled', sl >= maxScroll - 1 ? 'true' : 'false');
      }
    }

    function schedule() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(updateUi);
    }

    function scrollByPage(dir) {
      var step = Math.round(viewport.clientWidth * 0.82) * dir;
      viewport.scrollBy({ left: step, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        if (prevBtn.getAttribute('aria-disabled') !== 'true') scrollByPage(-1);
      });
      prevBtn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (prevBtn.getAttribute('aria-disabled') !== 'true') scrollByPage(-1);
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (nextBtn.getAttribute('aria-disabled') !== 'true') scrollByPage(1);
      });
      nextBtn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (nextBtn.getAttribute('aria-disabled') !== 'true') scrollByPage(1);
        }
      });
    }

    viewport.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    // ResizeObserver: feuert genau dann wenn Viewport-Dimensionen final settled
    // sind. Reagiert auch sauber auf Container-Resize (Accordion open/close etc.).
    // Ersetzt die alten setTimeout-Hacks (80ms, 400ms).
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(schedule);
      ro.observe(viewport);
    } else {
      // Fallback für sehr alte Browser ohne ResizeObserver
      schedule();
      setTimeout(schedule, 80);
      setTimeout(schedule, 400);
    }
  }

  // ---------- Trigger-Init ----------

  function initRoot(root) {
    if (root.dataset.lygInit === '1') return;
    root.dataset.lygInit = '1';

    // Slider-Logik (Pfeile, Progress) sofort initialisieren — die ist statisch
    // und braucht keine Netzwerk-Requests.
    initSlider(root);

    // Click-Listener auf Triggers sofort attachen (User könnte ja per Tastatur
    // ohne Scroll direkt zum Snippet springen)
    root.querySelectorAll('[data-lyg-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var vid = btn.getAttribute('data-lyg-vid');
        if (vid) openModal(vid, btn);
      });
    });

    // Thumbnails (Network-Requests an i.ytimg.com) erst laden wenn Section
    // im Viewport ist. Spart Bandwidth + Layout-Work wenn der User nie scrollt.
    // rootMargin: 200px → ein bisschen Vorlauf bevor Section erreicht wird,
    // damit Thumbnails schon da sind wenn der User ankommt.
    if (typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            upgradeThumbnails(root);
            io.disconnect(); // Einmal upgegraded reicht
          }
        });
      }, { rootMargin: '200px 0px' });
      io.observe(root);
    } else {
      // Fallback: sofort upgrade
      upgradeThumbnails(root);
    }
  }

  // ---------- Boot ----------

  function boot() {
    document.querySelectorAll('[data-lyg-root]').forEach(initRoot);
  }

  // Listener für nachträglichen Consent (User akzeptiert globale Consentmo-Wall
  // nachdem die Page geladen hat) → Thumbnails upgraden
  document.addEventListener('visitorConsentCollected', function() {
    document.querySelectorAll('[data-lyg-root]').forEach(upgradeThumbnails);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  window.LeonYoutubeGallery = { boot: boot };
})();